// src/config/socket.js
import { io } from "socket.io-client";

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL     ;   // default to local if env variable is not set
const socket = io(SOCKET_URL, {
  autoConnect: false,
  withCredentials: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  auth: {
    token: localStorage.getItem("token"), // or from your auth state/image.pngstore
  },
});

export default socket;
//for local :- "http://localhost:9000" 
//for server :- process.env.REACT_APP_SOCKET_URL

